var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "terms-array-editor"
  }, [_vm._l(_vm.termsItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "term-item mb-6"
    }, [_c('div', {
      staticClass: "term-header d-flex align-items-center mb-6"
    }, [_c('span', {
      staticClass: "term-order badge badge-primary mr-2"
    }, [_vm._v(_vm._s(index + 1))]), _c('b-form-input', {
      staticClass: "term-title-input flex-grow-1",
      attrs: {
        "placeholder": "請輸入條款標題"
      },
      on: {
        "input": _vm.emitUpdate
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    }), _c('div', {
      staticClass: "term-actions d-flex flex-shrink-0 ml-3"
    }, [index > 0 ? _c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-secondary",
        "title": "上移"
      },
      on: {
        "click": function click($event) {
          return _vm.moveUp(index);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-arrow-up"
    })]) : _vm._e(), index < _vm.termsItems.length - 1 ? _c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-secondary",
        "title": "下移"
      },
      on: {
        "click": function click($event) {
          return _vm.moveDown(index);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-arrow-down"
    })]) : _vm._e(), _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "title": "刪除此條款"
      },
      on: {
        "click": function click($event) {
          return _vm.removeItem(index);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-delete"
    })])], 1)], 1), _c('div', {
      staticClass: "term-meta"
    }, [_c('b-form-row', [_c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-2",
      attrs: {
        "label": "版本名稱",
        "label-size": "sm",
        "label-class": "term-meta-label"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "placeholder": "例如：v1 條款"
      },
      on: {
        "input": _vm.emitUpdate
      },
      model: {
        value: item.code,
        callback: function callback($$v) {
          _vm.$set(item, "code", $$v);
        },
        expression: "item.code"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('b-form-group', {
      staticClass: "mb-2",
      attrs: {
        "label": "版本號",
        "label-size": "sm",
        "label-class": "term-meta-label"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "placeholder": "例如：1.0.0"
      },
      on: {
        "input": _vm.emitUpdate
      },
      model: {
        value: item.version,
        callback: function callback($$v) {
          _vm.$set(item, "version", $$v);
        },
        expression: "item.version"
      }
    })], 1)], 1)], 1)], 1), _c('div', {
      staticClass: "term-content"
    }, [_vm.useEditor ? _c('ckeditor', {
      attrs: {
        "editor": _vm.editor,
        "config": _vm.editorConfig
      },
      on: {
        "input": _vm.emitUpdate
      },
      model: {
        value: item.content_text,
        callback: function callback($$v) {
          _vm.$set(item, "content_text", $$v);
        },
        expression: "item.content_text"
      }
    }) : _c('b-form-textarea', {
      attrs: {
        "placeholder": "請輸入內容",
        "rows": "4",
        "max-rows": "12"
      },
      on: {
        "input": _vm.emitUpdate
      },
      model: {
        value: item.content_text,
        callback: function callback($$v) {
          _vm.$set(item, "content_text", $$v);
        },
        expression: "item.content_text"
      }
    })], 1)]);
  }), _c('div', {
    staticClass: "add-term-btn mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "mdi mdi-plus mr-1"
  }), _vm._v(" 新增條款項目 ")])], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('b-button', {
    staticClass: "p-0 text-muted",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        _vm.showRawJson = !_vm.showRawJson;
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-code-json mr-1"
  }), _vm._v(" " + _vm._s(_vm.showRawJson ? '隱藏' : '顯示') + " JSON 原始碼 ")]), _vm.showRawJson ? _c('div', {
    staticClass: "mt-2"
  }, [_c('JsonEditor', {
    attrs: {
      "value": _vm.parsedJsonValue,
      "height": "400px",
      "options": {
        wrap: true
      }
    },
    on: {
      "input": _vm.handleJsonEditorInput
    }
  })], 1) : _vm._e()], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }